import React, { useState, useEffect, useCallback } from 'react';
import { decodeHTML } from '../../utils/helpers';

const SchoolSearch = ({ currentQuestion, storeAnswers, removeAnswer, answers }) => {
    const [searchText, setSearchText] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');

    const fetchSchoolData = useCallback(() => {
        fetch(`https://nu-partners-api.herokuapp.com/api/v1/school/by-name/${searchText}`)
            .then((response) => {
                if (response.status !== 200) {
                    console.error(`Looks like there was a problem. Status Code: ${response.status}`);

                    return;
                }

                response.json().then((data) => {
                    if (data.length > 0) {
                        const schoolData = data;

                        if (schoolData.length > 0) {
                            let schoolList = schoolData;

                            if (schoolData.length === 1 && schoolData[0].school === searchText) {
                                return;
                            }

                            if (searchText.length > 0) {
                                schoolList = schoolList.filter((school) =>
                                    school.school.toLowerCase().includes(searchText.toLowerCase())
                                );
                            }

                            if (schoolList.length === 0) {
                                setErrorMessage(
                                    'Sorry no matches for that school. Try skipping to the next question.!'
                                );
                                setSearchResults([]);

                                return;
                            }

                            setSearchResults(schoolList);
                            setErrorMessage('');
                        } else {
                            setSearchResults([]);
                            setErrorMessage('Sorry no matches for that school. Try skipping to the next question.!!');
                        }
                    }
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }, [searchText]);

    useEffect(() => {
        if (searchText.length < 3) {
            return;
        }

        fetchSchoolData();
    }, [searchText, fetchSchoolData]);

    const handleSearchClick = (event) => {
        fetchSchoolData();
    };

    const handleResultClick = (event) => {
        setSearchText(event.target.innerHTML);
        setSearchResults([]);
        setErrorMessage('');

        storeAnswers(
            0,
            {
                text: event.target.innerHTML,
                eligible: true,
                nextQuestion: null,
            },
            currentQuestion
        );
    };

    const handleSearchTextChange = (event) => {
        removeAnswer(currentQuestion);

        setSearchText(event.target.value);
    };

    const handleOnKeyPressed = (e) => {
        const code = e.keyCode || e.which;
        if (code === 13) {
            //13 is the enter keycode
            fetchSchoolData();
        }
    };

    return (
        <>
            <div className='searchWrapper long'>
                <input
                    className='searchText'
                    type='text'
                    onChange={handleSearchTextChange}
                    value={searchText}
                    onKeyUp={handleOnKeyPressed}
                />
                <button className='searchTextIcon' onClick={handleSearchClick} />
                {errorMessage && <p className='searchMessage error'>{errorMessage}</p>}

                {searchResults && (
                    <div className='searchResults'>
                        {searchResults.map((searchResult, idx) => {
                            return (
                                <span key={idx} onClick={handleResultClick}>
                                    {decodeHTML(searchResult.school)}
                                </span>
                            );
                        })}
                    </div>
                )}
            </div>
        </>
    );
};

export default SchoolSearch;
